export enum PlatformPermissions {
  CanImpersonate = "platform:security:loginOnBehalf",
}

export enum XApiPermissions {
  CanEditOrganization = "xapi:my_organization:edit",
  CanInviteUsers = "xapi:my_organization:user:invite",
  CanViewOrganizationOrders = "xapi:my_organization:order:view",
}

export enum VirtoPermissions {
  LoginOnBehalf = "platform:security:loginOnBehalf",
}

// Innovadis custom
export enum CustomPermissions {
  // Innovadis custom: explicit permission alias for checkout order creation.
  CanCreateOrder = "order:create",
  ShowBulkOrder = "order:create",
  ShowEditWishlist = "DKDCustomModule:edit_wishlist",
  ShowInvoiceHistory = "DKDCustomModule:invoice_history",
  ShowOpenOrders = "DKDCustomModule:open_orders",
  ShowOrderHistory = "DKDCustomModule:order_history",
  ShowPowerBI = "DKDCustomModule:view_powerbi",
  ShowPricing = "pricing:read",
  ShowUserManagement = "DKDCustomModule:user_management",
  ShowViewCompanyInformation = "DKDCustomModule:view_company_information",
  ShowWishlist = "DKDCustomModule:view_wishlist",
}
